import { render } from "./ProductGroupManager.vue?vue&type=template&id=5f47bb32"
import script from "./ProductGroupManager.vue?vue&type=script&lang=js"
export * from "./ProductGroupManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__